export default __webpack_public_path__ + "static/media/npc_04.ddb002b4.png";